import { useState, useEffect } from 'react';
import { FeatureFlags } from '../components/AdminSettings';

const defaultFeatures: FeatureFlags = {
  advancedSearch: false,
  bulkOperations: false,
  mediaUpload: false,
  analytics: false,
  notifications: false,
  advancedFilters: false,
  exportFeatures: false,
  clientCommunication: false,
  mobileFeatures: false,
  integrations: false,
};

export const useFeatureFlags = () => {
  const [features, setFeatures] = useState<FeatureFlags>(defaultFeatures);

  useEffect(() => {
    const savedFeatures = localStorage.getItem('adminFeatures');
    if (savedFeatures) {
      try {
        const parsed = JSON.parse(savedFeatures);
        setFeatures({ ...defaultFeatures, ...parsed });
      } catch (error) {
        console.error('Erreur lors du chargement des paramètres:', error);
      }
    }
  }, []);

  const isFeatureEnabled = (feature: keyof FeatureFlags): boolean => {
    return features[feature];
  };

  const toggleFeature = (feature: keyof FeatureFlags): void => {
    const newFeatures = {
      ...features,
      [feature]: !features[feature]
    };
    setFeatures(newFeatures);
    localStorage.setItem('adminFeatures', JSON.stringify(newFeatures));
  };

  return {
    features,
    isFeatureEnabled,
    toggleFeature,
  };
};